exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "site-footer {\n  max-width: 100%;\n  width: 74rem;\n  margin-left: auto;\n  margin-right: auto; }\n  @media screen and (max-width: 74rem) {\n    site-footer {\n      padding: 0 1rem; } }\n\nsite-footer {\n  margin: auto;\n  display: block;\n  padding: 1rem;\n  margin-top: 2rem;\n  border-top: 1px solid #dfdcdc;\n  margin-bottom: 1rem; }\n  @media screen and (max-width: 768px) {\n    site-footer {\n      padding-bottom: 3rem; } }\n", ""]);

// exports
